var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder_opened",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3027",
    "data-name": "Rectangle 3027",
    width: 24,
    height: 24,
    transform: "translate(-2 -4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M147.68,152h-5.76a1.92,1.92,0,0,0-1.91,1.92l-.01,12.1a1.926,1.926,0,0,0,1.92,1.92h15.36a1.926,1.926,0,0,0,1.92-1.92V155.84a1.926,1.926,0,0,0-1.92-1.92H149.6Z",
    transform: "translate(-141 -152)",
    fill: "#555bf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M141.686,169h16a2.044,2.044,0,0,0,1.915-1.6l2.732-8.8A1.259,1.259,0,0,0,161.1,157H145.571a2.141,2.141,0,0,0-1.943,1.6l-3.15,8.8A1.215,1.215,0,0,0,141.686,169Z",
    transform: "translate(-141.086 -153)",
    fill: "#878bfd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpened);
export default __webpack_public_path__ + "static/media/folder_opened.eaea5847.svg";
export { ForwardRef as ReactComponent };